import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "py-20 frm-footer__bg-top relative z-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "frm-footer__bg-img absolute top-0 left-0 z-[-1] h-full w-full bg-no-repeat bg-cover bg-center",
  style: {"background-image":"url('/assets/footer-bg.png')"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-20" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/shinagawa-logo.svg",
      alt: "logo",
      class: "h-[55px] mx-auto invert brightness-0 contrast-100 saturate-100"
    })
  ])
], -1)
const _hoisted_5 = { class: "flex flex-wrap justify-center px-[5%] mb-20 space-y-10 lg:space-y-0" }
const _hoisted_6 = { class: "text-center w-full lg:w-[20%]" }
const _hoisted_7 = {
  target: "_blank",
  ref: "noreferrer",
  href: "https://goo.gl/maps/5Wjpd6hTxudHPACt8",
  class: "text-white text-sm font-medium block mb-4"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-200 font-medium" }, "Address", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:block w-[1px] h-20 bg-primary-200 mx-10 self-center" }, null, -1)
const _hoisted_10 = { class: "text-center w-full lg:w-[20%]" }
const _hoisted_11 = {
  target: "_blank",
  ref: "noreferrer",
  href: "mailto:info@shinagawa-healthcare.ph",
  class: "text-white text-sm font-medium block"
}
const _hoisted_12 = {
  target: "_blank",
  ref: "noreferrer",
  href: "mailto:japanesedesk@shinagawa-healthcare.ph",
  class: "text-white text-sm font-medium block mb-4"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-200 font-medium" }, "Mailbox", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:block w-[1px] h-20 bg-primary-200 mx-10 self-center" }, null, -1)
const _hoisted_15 = { class: "text-center w-full lg:w-[20%]" }
const _hoisted_16 = {
  target: "_blank",
  ref: "noreferrer",
  href: "tel:(+63) 917-846-6762",
  class: "text-white text-sm font-medium block"
}
const _hoisted_17 = {
  target: "_blank",
  ref: "noreferrer",
  href: "tel:(+63) 962-067-3669",
  class: "text-white text-sm font-medium block mb-4"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-200 font-medium" }, "Trunkline", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:block w-[1px] h-20 bg-primary-200 mx-10 self-center" }, null, -1)
const _hoisted_20 = { class: "text-center w-full lg:w-[20%]" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-white text-sm font-medium block mb-4"
}, " Monday to Saturday 8AM to 5PM ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-200 font-medium" }, "Operating Hours", -1)
const _hoisted_23 = { class: "px-[5%] text-center" }
const _hoisted_24 = { class: "flex items-center justify-center space-x-2 mb-4" }
const _hoisted_25 = ["href"]
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-200 font-medium" }, "Copyright 2023 Shinagawa Diagnostics and Preventive Care. All Rights Reserved.", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "bg-primary-700 flex items-center justify-center flex-wrap px-[5%] pt-4 space-x-14" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://shinagawa.ph/data-privacy-notice/",
    target: "_blank",
    class: "text-white font-medium whitespace-nowrap mb-4"
  }, "Terms and Conditions"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://shinagawa.ph/data-privacy-notice/",
    target: "_blank",
    class: "text-white font-medium whitespace-nowrap mb-4"
  }, "Privacy Policy")
], -1)

import { MapPinIcon, EnvelopeIcon, PhoneIcon, ClockIcon } from "@heroicons/vue/24/solid";


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomNavigation',
  setup(__props) {

const socialaccts = [
    {
        icon: '/assets/icon/ic-facebook.svg',
        link: 'https://www.facebook.com/shinagawadiagnostic',
    },
    {
        icon: '/assets/icon/ic-instagram.svg',
        link: 'https://www.instagram.com/shinagawadiagnostic/',
    },
    {
        icon: '/assets/icon/ic-youtube.svg',
        link: 'https://www.youtube.com/@ShinagawaPhilippines',
    },
    {
        icon: '/assets/icon/ic-linkedin.svg',
        link: 'https://www.linkedin.com/in/shinagawa-philippines/',
    }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(MapPinIcon), { class: "w-10 mx-auto text-primary-200 mb-4" }),
          _createElementVNode("a", _hoisted_7, " 8F & 23F Ore Central Tower, Bonifacio Global City, Taguig ", 512),
          _hoisted_8
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(EnvelopeIcon), { class: "w-10 mx-auto text-primary-200 mb-4" }),
          _createElementVNode("a", _hoisted_11, " info@shinagawa-healthcare.ph ", 512),
          _createElementVNode("a", _hoisted_12, " japanesedesk@shinagawa-healthcare.ph ", 512),
          _hoisted_13
        ]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_unref(PhoneIcon), { class: "w-10 mx-auto text-primary-200 mb-4" }),
          _createElementVNode("a", _hoisted_16, " (+63) 917-846-6762 – GLOBE ", 512),
          _createElementVNode("a", _hoisted_17, " (+63) 962-067-3669 – SMART ", 512),
          _hoisted_18
        ]),
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_unref(ClockIcon), { class: "w-10 mx-auto text-primary-200 mb-4" }),
          _hoisted_21,
          _hoisted_22
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socialaccts, (i) => {
            return _createElementVNode("a", {
              key: i,
              href: i.link,
              target: "_blank",
              class: "w-8 h-8 bg-white rounded-full flex items-center justify-center",
              ref_for: true,
              ref: "noreferrer"
            }, [
              _createElementVNode("img", {
                src: i.icon,
                alt: ""
              }, null, 8, _hoisted_26)
            ], 8, _hoisted_25)
          }), 64))
        ]),
        _hoisted_27
      ])
    ]),
    _hoisted_28
  ]))
}
}

})